export const pageLimit = 50;
/** Emailed CSV exports (contacts/invoices) are capped at this many records */
export const maxExportRecords = 20000;
//# sourceMappingURL=pageLimit.js.map